import { isPolygon } from '@/modules/Editor/annotationTypes/polygon'
import { EditorEvents, ToolEvents } from '@/modules/Editor/eventBus'
import type { Action } from '@/modules/Editor/managers/actionManager'
import type { Annotation } from '@/modules/Editor/models/annotation/Annotation'
import { shallowCloneAnnotation } from '@/modules/Editor/models/annotation/cloneAnnotation'
import { subtractPolygons } from '@/modules/Editor/subtractPolygons'
import type { View } from '@/modules/Editor/views/view'
import { ToolName } from '@/modules/Editor/tools/types'

export const subtractPolygonsAction = (
  view: View,
  firstAnnotation: Annotation,
  secondAnnotation: Annotation,
): Action => {
  const previousSecondAnnotationData = secondAnnotation.data

  return {
    do(): boolean {
      if (!isPolygon(firstAnnotation.data) || !isPolygon(secondAnnotation.data)) {
        return false
      }

      const subtractedPolygon = subtractPolygons(firstAnnotation.data, secondAnnotation.data)
      if (subtractedPolygon.path.length === 0) {
        EditorEvents.message.emit({
          content: 'You cannot delete entire annotations with subtractions',
          level: 'warning',
        })

        return false
      }

      const updatedAnnotation = shallowCloneAnnotation(secondAnnotation, {
        data: {
          ...secondAnnotation.data,
          path: subtractedPolygon.path,
          additionalPaths: subtractedPolygon.additionalPaths,
        },
      })

      ToolEvents.polygonUpdating.emit(
        { toolName: ToolName.Edit, lastHotkeyPressed: null, editing: false },
        [updatedAnnotation.id],
      )
      view.annotationManager.updateAnnotation(updatedAnnotation)

      return true
    },
    undo(): boolean {
      secondAnnotation.data = previousSecondAnnotationData
      view.annotationManager.updateAnnotation(secondAnnotation)
      return true
    },
  }
}
